import { Flex } from "@evergis/ui";
import styled from "styled-components";

export const FilterByServiceTypeContainer = styled(Flex)`
  margin-right: 0.5rem;
  flex-wrap: nowrap;
`;
